import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./AdminLayout.css";
import AdminHeader from "./AdminHeader";


function AdminLayout({ children }) {
  const location = useLocation();

  return (
    <>
      <AdminHeader />
      <div className="admin-layout">
        {/* ---------- Sidebar ---------- */}
        <aside className="admin-sidebar">
          <div className="sidebar-header" />
          <nav className="sidebar-nav">
            {/* ---------- Dashboard ---------- */}
            <Link
              to="/dashboard"
              className={`nav-link ${location.pathname === "/dashboard" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 11.5L12 4l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1v-8.5z" fill="currentColor" />
                </svg>
              </span>
              Dashboard
            </Link>
            {/* ---------- Categories ---------- */}
            <p className="nav-section">Categories</p>
            <Link
              to="/upload-category"
              className={`nav-link ${location.pathname === "/upload-category" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              Add Category
            </Link>
            <Link
              to="/category-manager"
              className={`nav-link ${location.pathname === "/category-manager" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7a2 2 0 0 1 2-2h3l2 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" fill="currentColor" />
                </svg>
              </span>
              Manage Category
            </Link>

            {/* ---------- Services ---------- */}
            <p className="nav-section">Services</p>
            <Link
              to="/upload-service"
              className={`nav-link ${location.pathname === "/upload-service" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="3" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
                  <path d="M3 17l4-4 4 4 6-6 4 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                </svg>
              </span>
              Upload Service
            </Link>
            <Link
              to="/service-manager"
              className={`nav-link ${location.pathname === "/service-manager" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7a2 2 0 0 1 2-2h3l2 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" fill="currentColor" />
                </svg>
              </span>
              Manage Services
            </Link>

            {/* ---------- Testimonials ---------- */}
            <p className="nav-section">Testimonials</p>
            <Link
              to="/upload-testimonial"
              className={`nav-link ${location.pathname === "/upload-testimonial" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z" fill="currentColor" />
                </svg>
              </span>
              Add Testimonial
            </Link>
            <Link
              to="/testimonial-manager"
              className={`nav-link ${location.pathname === "/testimonial-manager" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7a2 2 0 0 1 2-2h3l2 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" fill="currentColor" />
                </svg>
              </span>
              Manage Testimonial
            </Link>

            {/* ---------- Blogs (NEW) ---------- */}
            <p className="nav-section">Blogs</p>
            <Link
              to="/upload-blog"
              className={`nav-link ${location.pathname === "/upload-blog" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 6h16M4 12h10M4 18h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              Add Blog
            </Link>
            <Link
              to="/blog-manager"
              className={`nav-link ${location.pathname === "/blog-manager" ? "active" : ""}`}
            >
              <span className="nav-icon" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7a2 2 0 0 1 2-2h3l2 3h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" fill="currentColor" />
                </svg>
              </span>
              Manage Blogs
            </Link>
          </nav>
        </aside>

        {/* ---------- Main Content ---------- */}
        <main className="admin-content">{children}</main>
      </div>
    </>
  );
}

export default AdminLayout;